import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MdbSidenavComponent } from 'mdb-angular-ui-kit/sidenav';

@Component({
  selector: 'app-settings-sidebar',
  templateUrl: './settings-sidebar.component.html',
  styleUrls: ['./settings-sidebar.component.scss'],
  standalone: false,
})
export class SettingsSidebarComponent implements OnChanges, OnDestroy {
  @Input() isLoggedInEndUser = false;
  @Input() deviceId: string | null = null;
  @Input() canBeginTest = false;
  @Input() testEndTime: string | null = null;
  @Input() remainingTimeInMilliseconds = 0;
  @Input() device: {
    gps: { status: string; date: string };
    network: { status: string; date: string };
  } = {
    gps: { status: '', date: '' },
    network: { status: '', date: '' },
  };
  @Input() isLoading: {
    gpsCheck: boolean;
    networkCheck: boolean;
    testAction: boolean;
    downloadLogs: boolean;
    downloadRrmsLogs: boolean;
  } = {
    gpsCheck: false,
    networkCheck: false,
    testAction: false,
    downloadLogs: false,
    downloadRrmsLogs: false,
  };

  @Output() gpsCheck = new EventEmitter<void>();
  @Output() networkCheck = new EventEmitter<void>();
  @Output() downloadLogs = new EventEmitter<void>();
  @Output() downloadRrmsLogs = new EventEmitter<void>();
  @Output() beginTest = new EventEmitter<void>();
  @Output() stopTest = new EventEmitter<void>();
  @Output() editConfiguration = new EventEmitter<void>();

  @ViewChild('sidenav', { static: false }) public sidenav!: MdbSidenavComponent;

  displayMinutes = '00';
  displaySeconds = '00';
  private timerInterval?: ReturnType<typeof setInterval>;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['remainingTimeInMilliseconds'] ||
      changes['testEndTime']
    ) {
      if (this.testEndTime && this.remainingTimeInMilliseconds > 0) {
        this.startLocalTimer(this.remainingTimeInMilliseconds);
      } else {
        this.clearLocalTimer();
      }
    }
  }

  ngOnDestroy(): void {
    this.clearLocalTimer();
  }

  onOpen(): void {
    this.sidenav.toggle();
  }

  onClose(): void {
    this.sidenav.toggle();
  }

  private startLocalTimer(ms: number): void {
    this.clearLocalTimer();
    let left = ms;
    const tick = () => {
      if (left <= 0) {
        this.displayMinutes = '00';
        this.displaySeconds = '00';
        this.clearLocalTimer();
        return;
      }
      this.displayMinutes = String(Math.floor(left / 60000)).padStart(2, '0');
      this.displaySeconds = String(Math.floor((left % 60000) / 1000)).padStart(
        2,
        '0',
      );
      left -= 1000;
    };
    tick();
    this.timerInterval = setInterval(tick, 1000);
  }

  private clearLocalTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = undefined;
    }
    this.displayMinutes = '00';
    this.displaySeconds = '00';
  }
}
